const AccordionInitiator = {
  async init ({ accordionButtonContainer }) {
    this._accordionButtonContainer = accordionButtonContainer

    await this._renderAccordion()
  },

  async _renderAccordion () {
    await this._renderToggle()
  },

  async _renderToggle () {
    const accordionButton = document.getElementsByClassName('accordion')
    let i

    for (i = 0; i < accordionButton.length; i++) {
      accordionButton[i].addEventListener('click', function () {
        this.classList.toggle('active')
        const panel = this.nextElementSibling
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px'
        }
      })
    }
  }
}

export default AccordionInitiator
